import React, { Component } from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import Modal from './Modal';
import AnimatedTitle from './AnimatedTitle';

const welcomeMessages = [
  {
    id: 1,
    text: `В разделе Обучение Вы сможете просмотреть опубликованные обучающие материалы по разным категориям и темам. 
      Некоторые материалы доступны для скачивания.`,
  },
  {
    id: 2,
    text: `В разделе Форум доступно обсуждение актуальных вопросов. Вы сможете найти ответ на важный для Вас вопрос 
    и поучаствовать в обсуждениях.`,
  },
  {
    id: 3,
    text: `В разделе Практика доступны для просмотра видеоролики, иллюстрирующие случаи из практики
    <span class="red">Адвокатов Бренда</span>. Каждый случай участвует в конкурсе, Вы можете оставить свой
    голос за понравившийся кейс. В каждом конкурсе у Вас доступно ограниченное количество голосов. В любой
    момент до завершения конкурса Вы можете отозвать свой голос.`,
  },
  {
    id: 4,
    text: `В разделе Новости Вам доступна последняя информация об актуальных событиях компании. Новости отображаются
    в хронологическом порядке – сверху самые свежие. Следите за нашими новостями и будьте в курсе последних
    событий!`,
  },
];

function WelcomeSlide(props) {
  const { item } = props;
  return (
    <div className="welcome-modal__slide">
      <div
        className="welcome-modal__text"
        dangerouslySetInnerHTML={{ __html: item.text }}
      />
    </div>
  );
}

export default class WelcomeModal extends Component {
  constructor(props) {
    super(props);
    
    this.sliderSettings = {
      autoplay: false,
      swipe: false,
      touchMove: false,
      infinite: false,
      fade: true,
      arrows: false,
      adaptiveHeight: true,
    };
    
    this.state = {
      disableNextArrow: false,
      checkboxChecked: false,
      currentSlide: 1,
    };
  }

  handleCloseBtn = () => {
    this.props.unmount(this.state.checkboxChecked);
  }

  next() {
    const nextSlide = this.state.currentSlide + 1;
    if (nextSlide <= welcomeMessages.length) {
      this.setState({ currentSlide: nextSlide });
      this.slider.slickNext();
    }
    if (nextSlide >= welcomeMessages.length) {
      this.setState({ disableNextArrow: true });
    }
  }

  render() {
    const { disableNextArrow, checkboxChecked } = this.state;
    return (
      <Modal contentClass="bg-dragonfly4" modalCloseButton={false}>
        <div className="welcome-modal__title">
          <div className="welcome-note">
            Добро пожаловать на сайт
            <AnimatedTitle />
            компании CooperVision
          </div>
        </div>

        <Slider
          {...this.sliderSettings}
          ref={slider => (this.slider = slider)}
          className="welcome-modal__slider"
        >
          {welcomeMessages.map(item => (
            <WelcomeSlide key={item.id} item={item} />
          ))}
        </Slider>

        <div className="welcome-modal__button-group">
          <button
            disabled={disableNextArrow}
            className="btn"
            onClick={() => this.next()}
          >
            Далее
          </button>
          <button className="btn -simple" onClick={this.handleCloseBtn.bind(this)}>
            Закрыть
          </button>
        </div>

        <div className="welcome-modal__checkbox">
          <input
            id="ch1"
              type="checkbox"
              checked={checkboxChecked}
              onChange={() => this.setState({ checkboxChecked: !checkboxChecked })
            }
          />
          <label htmlFor="ch1">Больше не показывать приветствие</label>
        </div>
      </Modal>
    );
  }

  static propTypes = {
    unmount: PropTypes.func.isRequired,
  };
}
